import { useEffect, useState } from "react";
import { Container } from "@mui/material";
import useStore from "../store/store";
import userServices from "../services/user";
import { Text, Heading, Button, FormatPhone, ArrowDownChip } from "../controls";

function AddProfile({ setIsOpen, reload }) {
	let [name, setName] = useState("");
	let [shopName, setShopName] = useState("");
	let [address, setAddress] = useState("");
	let [additionalPhone, setAdditionalPhone] = useState("");
	let [description, setDescription] = useState("");
	let [note, setNote] = useState("");
	let [nickName, setNickName] = useState("");

	const {
		token,
		setErrorMessage,
		setSuccessMessage,
		setIsLoading,
		company,
		setCompany,
	} = useStore((state) => state);

	useEffect(() => {
		if (company) {
			setName(company.name || "");
			setShopName(company.shopName || "");
			setAddress(company.address || "");
			setAdditionalPhone(company.additionalPhone || "");
			setDescription(company.description || "");
			setNote(company.note || "");
			setNickName(company.nickName || "");
		}
	}, []);

	const updateData = () => {
		setIsLoading(true);
		additionalPhone =
			additionalPhone.trim().length === 12 ? additionalPhone : "";
		setIsLoading(true);
		let data = {
			id: company._id,
			name,
			shopName,
			address,
			additionalPhone,
			description,
			note,
			nickName,
		};
		userServices.update(token, data).then((r) => {
			if (r.error) {
				setErrorMessage(r.error);
				setIsLoading(false);
				return;
			}
			if (r.data) {
				setCompany(r.data);
				setSuccessMessage("Data updated successfully");
				reload();
				setIsOpen(false);
				setIsLoading(false);
			}
		});
	};

	return (
		<>
			<Container sx={{ overflow: "auto" }}>
				<Heading text="Update Profile" variant="h6" />
				<Text label="Title" value={name} onChange={setName} />
				<Text
					label="Shop Name"
					value={shopName}
					onChange={setShopName}
				/>
				<Text label="Address" value={address} onChange={setAddress} />
				<FormatPhone
					label="Additional phone number"
					value={additionalPhone}
					onChange={setAdditionalPhone}
				/>
				<Text
					label="Description"
					value={description}
					onChange={setDescription}
				/>
				<Text label="Note" value={note} onChange={setNote} />
				<Text
					label="Nick Name"
					value={nickName}
					onChange={setNickName}
				/>
				<Button
					icon={<ion-icon name="add-circle-outline"></ion-icon>}
					onClick={updateData}
					text={"Update"}
				/>
				<ArrowDownChip onClick={setIsOpen} />
			</Container>
		</>
	);
}

export default AddProfile;
